var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { FormImgService } from './img.service';
import { ColumnBaseService } from '../base/columnbase.service';
import { FileService } from '../file/file.service';
var FormImgComponent = /** @class */ (function (_super) {
    __extends(FormImgComponent, _super);
    function FormImgComponent(service, baseService, imgService, fileService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.imgService = imgService;
        _this.fileService = fileService;
        _this.cacheInvalidate = '';
        _this.hidden = false;
        _this.host = _this.imgService.host;
        return _this;
    }
    FormImgComponent.prototype.ngOnChanges = function (changes) {
        // super.ngOnChanges(changes);
        if (changes.col) {
            this.setParams();
        }
        if (changes.val) {
            this.hidden = !this.fileService.checkImageFile(this.fileService.getExtension(this.val));
        }
    };
    FormImgComponent.prototype.ngOnInit = function () {
        // super.ngOnInit();
    };
    FormImgComponent.prototype.setParams = function () {
        if (!this.imgElement) {
            return;
        }
        var element = this.imgElement.nativeElement;
        var params = this.col.params || {};
        element.alt = params.alt ? params.alt : '';
        var style = params.style;
        if (typeof style !== 'undefined') {
            for (var _i = 0, _a = Object.keys(style); _i < _a.length; _i++) {
                var key = _a[_i];
                if (typeof element.style[key] !== 'undefined') {
                    element.style[key] = style[key];
                }
            }
        }
        if (params.cache === false) {
            this.cacheInvalidate = this.imgService.updateCacheInvalidate();
        }
        else {
            this.cacheInvalidate = '';
        }
    };
    FormImgComponent.decorators = [
        { type: Component, args: [{
                    selector: 'column-img',
                    template: '<img [hidden]="hidden" [lazyLoad]="!!val && (host + val + cacheInvalidate)" [key]="key" [col]="col" columnDir #img>',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    FormImgComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: FormImgService },
        { type: FileService }
    ]; };
    FormImgComponent.propDecorators = {
        imgElement: [{ type: ViewChild, args: ['img',] }]
    };
    return FormImgComponent;
}(ColumnBaseComponent));
export { FormImgComponent };
//# sourceMappingURL=img.component.js.map